import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import axios from 'axios';
// import emailjs from 'emailjs-com';
import Notiflix from 'notiflix';

const DemoProduct = (props) => {

    useDocTitle('MLD | Molad e Konsult - Demo our products')

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [demoProducts, setDemoProducts ] = useState([])
    const [errors, setErrors] = useState([])


    const handleChange = (e) => {
        const value = e.target.value
        const checked = e.target.checked
        errors.products = []
        if(checked) {
            setDemoProducts([
                ...demoProducts, value
            ])
        } else {
            setDemoProducts(demoProducts.filter( (e) => (e !== value )))
        }
       
    }
    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
    }
    
    function sendEmail(e) {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = 'Loading...';
        let fData = new FormData();
        fData.append('first_name', firstName)
        fData.append('last_name', lastName)
        fData.append('email', email)
        fData.append('phone_number', phone)
        fData.append('message', message)
        fData.append('products', demoProducts)

        // emailjs.sendForm('service_7uy4ojg', 'template_et9wvdg', e.target, 'user_uE0bSPGbhRTmAF3I2fd3s')
        //   .then((result) => {
        //       console.log(result.text);
        //       Notiflix.Report.success(
        //         'Success',
        //         '"Thanks for sending a message, we\'ll be in touch soon."',
        //         'Okay',
        //         );
        //   }, (error) => {
        //       console.log(error.text);
        //       Notiflix.Report.failure(
        //         'An error occured',
        //         'Please try sending the message again.',
        //         'Okay',
        //         );
        //   });

        axios({
            method: "post",
            url: process.env.REACT_APP_DEMO_REQUEST_API,
            data: fData,
            headers: {
                'Content-Type':  'multipart/form-data'
            }
        })
        .then(function (response) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'send message';
            clearInput()
            //handle success
            Notiflix.Report.success(
                'Success',
                response.data.message,
                'Okay',
            );
        })
        .catch(function (error) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'send message';
            //handle error
            const { response } = error;
            if(response.status === 500) {
                Notiflix.Report.failure(
                    'An error occurred',
                    response.data.message,
                    'Okay',
                );
            }
            if(response.data.errors !== null) {
                setErrors(response.data.errors)
            }
            
        });
    }
    return (
        <>
            <NavBar />
            <div id='demo' className="flex justify-center items-center pt-24 w-full bg-gray-50 pb-16 lg:pb-24">
                <div className="container-app" data-aos="zoom-in">
                    <div className="flex flex-col lg:flex-row gap-8 items-start">
                        <form onSubmit={sendEmail} id="demoProductForm" className="w-full lg:w-2/3">
                            <div className="card p-6 md:p-10">
                                <h1 className="font-bold text-center lg:text-left text-brand uppercase text-2xl md:text-3xl mb-6">Demo our products</h1>

                                <fieldset className="mb-2">
                                    <legend className="field-label mb-2">Pilih Produk*</legend>
                                    <div className="space-y-3">
                                        <div className="flex items-center">
                                            <input
                                                id="checkbox-1"
                                                aria-describedby="checkbox-1"
                                                type="checkbox"
                                                className="h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand/30"
                                                value="business_management_system" onChange={handleChange}
                                             />
                                            <label htmlFor="checkbox-1" className="ml-3 text-base font-medium text-slate-800">Business Management System</label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id="checkbox-2"
                                                aria-describedby="checkbox-2"
                                                type="checkbox"
                                                className="h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand/30"
                                                value="school_management_portal" onChange={handleChange}
                                                />
                                            <label htmlFor="checkbox-2" className="ml-3 text-base font-medium text-slate-800">School Management Portal</label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id="checkbox-3"
                                                aria-describedby="checkbox-3"
                                                type="checkbox"
                                                className="h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand/30"
                                                value="payroll_management_system" onChange={handleChange}
                                            />
                                            <label htmlFor="checkbox-3" className="ml-3 text-base font-medium text-slate-800">Payroll Management System</label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id="checkbox-4"
                                                aria-describedby="checkbox-4"
                                                type="checkbox"
                                                className="h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand/30"
                                                value="event_management_system" onChange={handleChange}
                                            />
                                            <label htmlFor="checkbox-4" className="ml-3 text-base font-medium text-slate-800">Event Management System</label>
                                        </div>
                                    </div>
                                    {errors &&
                                        <p className="text-red-500 text-sm mt-2">{errors.products}</p>
                                    }
                                </fieldset>

                                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-6">
                                    <div>
                                        <label className="field-label">First Name*</label>
                                        <input
                                            name="first_name"
                                            className="input-field"
                                            type="text"
                                            placeholder="First Name"
                                            value={firstName}
                                            onChange={(e)=> setFirstName(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-1">{errors.first_name}</p>
                                        }
                                    </div>

                                    <div>
                                        <label className="field-label">Last Name*</label>
                                        <input
                                            name="last_name"
                                            className="input-field"
                                            type="text"
                                            placeholder="Last Name"
                                            value={lastName}
                                            onChange={(e)=> setLastName(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-1">{errors.last_name}</p>
                                        }
                                    </div>

                                    <div>
                                        <label className="field-label">Email*</label>
                                        <input
                                            name="email"
                                            className="input-field"
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(e)=> setEmail(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                                        }
                                    </div>

                                    <div>
                                        <label className="field-label">Phone*</label>
                                        <input
                                            name="phone_number"
                                            className="input-field"
                                            type="number"
                                            placeholder="Phone"
                                            value={phone}
                                            onChange={(e)=> setPhone(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-1">{errors.phone_number}</p>
                                        }
                                    </div>
                                </div>
                                <div className="mt-5">
                                    <label className="field-label">Message*</label>
                                    <textarea
                                        name="message"
                                        placeholder="Message"
                                        className="input-field h-32"
                                        value={message}
                                        onChange={(e)=> setMessage(e.target.value)}
                                        onKeyUp={clearErrors}
                                    ></textarea>
                                    {errors &&
                                        <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                                    }
                                </div>
                                <div className="mt-6">
                                    <button type="submit" id="submitBtn" className="btn-primary w-full uppercase">
                                        Send Message
                                    </button>
                                </div>
                            </div>
                        </form>

                        <div className="w-full lg:w-1/3 px-8 py-8 bg-brand rounded-2xl shadow-card text-white">
                            <div className="flex flex-col">
                                <div className="flex my-4">
                                    <div className="flex flex-col">
                                        <i className="fas fa-map-marker-alt pt-2 pr-3" />
                                    </div>
                                    <div className="flex flex-col">
                                        <h2 className="text-xl font-semibold">Office Address</h2>
                                        <p className="text-white/70">Ilo Awela, Ota, Ogun State</p>
                                    </div>
                                </div>

                                <div className="flex my-4">
                                    <div className="flex flex-col">
                                    <i className="fas fa-phone-alt pt-2 pr-3" />
                                    </div>

                                    <div className="flex flex-col">
                                        <h2 className="text-xl font-semibold">Call Us</h2>
                                        <p className="text-white/70">Tel: 08055384406</p>

                                        <div className='mt-5'>
                                            <h2 className="text-xl font-semibold">Send an E-mail</h2>
                                            <p className="text-white/70">info@mld.ng</p>
                                        </div>

                                    </div>
                                </div>

                                <div className="flex my-4">
                                    <a href="https://www.facebook.com/ENLIGHTENEERING/" target="_blank" rel="noreferrer" className="rounded-full flex justify-center items-center bg-white h-9 w-9 text-brand mr-2 transition-transform duration-200 hover:scale-110">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className='fill-current'><path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path></svg>
                                    </a>
                                    <a href="https://www.linkedin.com/company/enlighteneering-inc-" target="_blank" rel="noreferrer" className="rounded-full flex justify-center items-center bg-white h-9 w-9 text-brand transition-transform duration-200 hover:scale-110">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className='fill-current'><circle cx="4.983" cy="5.009" r="2.188"></circle><path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path></svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default DemoProduct;